// extracted by mini-css-extract-plugin
export default {"tabsList":"YJb8j3E7HAzkWQtZOh9b"};